import { Spacer, TextCapitalized } from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import "../../../../i18n/i18n";

export const EmptyChart = (props: { isBalanceChart?: boolean }) => {
  const { t } = useTranslation();

  return (
    <StyledEmptyCard>
      <Spacer y={1} />
      <StyledCardTitle>
        <TextCapitalized>
          {props.isBalanceChart
            ? t("dashboard.charts.balance.title.empty")
            : t("dashboard.charts.title.empty")}
        </TextCapitalized>
      </StyledCardTitle>
    </StyledEmptyCard>
  );
};

const StyledCardTitle = styled.div`
  ${typographies["Body/M"]}
`;
const StyledEmptyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
